import React, { PureComponent, Fragment } from 'react';

import PropTypes from 'prop-types';

import {
  FileUploadSizeModal,
  FileUploadExtensionModal,
  FileUploadLimitModal
} from './FileUploadModals';

import { FILE_EXCEPTIONS } from '../constants';

export default class FileUploadValidations extends PureComponent {
  static propTypes = {
    maxFileSize: PropTypes.number,
    onConfirm: PropTypes.func,
    resetException: PropTypes.func,
    children: PropTypes.node,
    exception: PropTypes.object
  };

  static defaultProps = {
    exception: null
  };

  get actions() {
    const { resetException, onConfirm } = this.props;

    return {
      onConfirm: onConfirm ? onConfirm : resetException,
      onClose: resetException
    };
  }

  get isBigFile() {
    const { exception } = this.props;

    return exception === FILE_EXCEPTIONS.BIG_FILE;
  }

  get isInvalidExtension() {
    const { exception } = this.props;

    return exception === FILE_EXCEPTIONS.INVALID_EXTENSION;
  }

  get reachedFilesLimit() {
    const { exception } = this.props;

    return exception === FILE_EXCEPTIONS.FILES_LIMIT;
  }

  render() {
    return (
      <Fragment>
        {this.renderModals()}

        {this.props.children}
      </Fragment>
    );
  }

  renderModals() {
    if (this.isInvalidExtension) {
      return <FileUploadExtensionModal {...this.actions} />;
    } else if (this.isBigFile) {
      return (
        <FileUploadSizeModal
          {...this.actions}
          maxFileSize={this.props.maxFileSize}
        />
      );
    } else if (this.reachedFilesLimit) {
      return <FileUploadLimitModal {...this.actions} />;
    }
  }
}
